
import GeneratePDFDownload from "../Shared/GeneratePDFDownload";
import { useState } from "react";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import ReactDOM from "react-dom";
import Button from "../../../common/Button";
import { useDispatch, useSelector } from "react-redux";
import { generateGlobalDownloadPDF } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";

export default function SosFooter({sosData, classes}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)

    function modalWarningHandler() {
        setShowModal(true)
    }

    function closeModalHandler() {
        setShowModal(false)
    }

    async function printInvoiceHandler() {
        setLoading(true)
        try {
            let response =  await generateGlobalDownloadPDF(userToken, activeCase.case.id, 'sos-invoice-pdf')

            if (response && response.errorMessage) {
                dispatch(notificationActions.setError(response))     
            } else {   
                const fileURL = URL.createObjectURL(response)
                
                // force download, if not the file needs to be saved firt in the app and then generate a link...
                const a = document.createElement("a");
                a.href = fileURL;
                a.download = "patient_sos_invoice.pdf"; 
                a.click();
                
            }

            closeModalHandler()
        } finally {
            setLoading(false)
        }
    }


    let dataIsNotComplete = sosData.some(item => !item.completed)

    return <>
        <div className={`${classes.row} ${classes.row_end}`}>
            <GeneratePDFDownload url={'sos-invoice-pdf'} fileName={'patient_sos_invoice.pdf'} disabled={!sosData || sosData.length == 0} modalWarning={dataIsNotComplete ? modalWarningHandler : null}>
                <i className="ti ti-printer"></i> Print Patient SOS Invoice
            </GeneratePDFDownload>
        </div>


        {showModal && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'Print Patient SOS Invoice'} noOverflow={true}>
                        <PannelBody>
                            <p>Incomplete charges will not appear on the invoice. Would you like to print the invoice anyway?</p>
                        </PannelBody>
                        <PannelBody>
                            <div className="flex-container">
                                <Button click={printInvoiceHandler} btnStyle={'btn_dark'} isLoading={loading}>Yes</Button>
                                <Button click={closeModalHandler}>Cancel</Button>
                            </div>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}